/**
 * Extra
 **/
jQuery(document).ready(function() {
    // item
    if ($('.prestaItem').length) {
        $('.prestaItem').each(function() {
            var $this = $(this);
            var id = $this.data("id");
            var template = $this.data("template");
            var showdispo = $this.data("showdispo");
            var showtarif = $this.data("showtarif");
            var lg = $this.data("lang");
            Apidae_Util.ajaxSend($this);

            $.ajax({
                url: base_url + 'services/getPrestaItem/',
                type: 'GET',
                data: { idPrestation: id, templateDetail: template, showDispo: showdispo, showTarif: showtarif, lang: lg }
            }).done(function(data) {
                $this.append(data);
                Apidae_Util.ajaxComplete($this);
            });
        });
    }

    // slide
    // <div class="prestasSlider" data-url="http://www.fmz.local/fr/animation" data-type="slideEvent" data-filter="filter1826=31" data-nb="16" data-lang="fr">&nbsp;</div>
    if ($('.prestasSlider').length) {
        $('.prestasSlider').each(function() {
            var $this = $(this);
            var filter = $this.data("filter");
            var type = $this.data("type");
            var nb = $this.data("nb");
            var lang = $this.data("lang");
            var date = $this.data("date");
            var href = $this.data("url") + '/slider?type=' + type + '&nb=' + nb + '&lang=' + lang + '&date=' + date + '&' + filter;
            Apidae_Util.ajaxSend($this);

            $.get(href, function(data) {
                $($this).append(data);
                $('.slider-prestas').bxSlider({
                    slideWidth: 333,
                    slideMargin: 15,
                    minSlides: 1,
                    maxSlides: 3,
                    nextSelector: '#slider-next',
                    prevSelector: '#slider-prev',
                    nextText: '<i class="fal fa-2x fa-angle-right"></i>',
                    prevText: '<i class="fal fa-2x fa-angle-left"></i>',
                    pager: false,
                    auto: true
                });
                Apidae_Util.ajaxComplete($this);
            });
        });
    }

    // slide
    // if($('#prestasSlider').length){
    //     var $this = $('#prestasSlider');
    //     var type = $this.data("type");
    //     var nb = $this.data("nb");
    //     var lang = $this.data("lang");
    //     var date = $this.data("date");
    //     var href = $this.data("url") + '/slider/?type=' + type + '&nb=' + nb + '&lang=' + lang + '&date=' + date;
    //     Apidae_Util.ajaxSend('#prestasSlider');

    //     $.get(href, function(data) {
    //         $('#prestasSlider').append(data);
    //         $('.slider-prestas').bxSlider({
    //             slideWidth: 333,
    //             slideMargin: 15,
    //             minSlides: 1,
    //             maxSlides: 3,
    //             nextSelector: '#slider-next',
    //             prevSelector: '#slider-prev',
    //             nextText: '<span class="fc-icon fc-icon-right-single-arrow"></span>',
    //             prevText: '<span class="fc-icon fc-icon-left-single-arrow"></span>',
    //             pager: false,
    //             auto: true
    //         });
    //         Apidae_Util.ajaxComplete('#prestasSlider');
    //     });
    // }

    // slideShow
    if ($('#prestasSliderEvent').length) {
        var $this = $('#prestasSliderEvent');
        var type = $this.data("type");
        var nb = $this.data("nb");
        var lang = $this.data("lang");
        var date = $this.data("date");
        var href = $this.data("url") + '/slider/?type=' + type + '&nb=' + nb + '&lang=' + lang + '&date=' + date;
        Apidae_Util.ajaxSend('#prestasSliderEvent');

        $.get(href, function(data) {
            $('#prestasSliderEvent').append(data);
            $('.slider-extra-show').bxSlider({
                mode: 'fade',
                speed: 2000,
                default: 6000,
                slideWidth: 1070,
                minSlides: 1,
                maxSlides: 1,
                moveSlides: 1,
                slideMargin: 0,
                pagerCustom: '#bx-pager-extra-show',
                auto: true,
                captions: true,
                easing: 'ease-in'
            });
            Apidae_Util.ajaxComplete('#prestasSliderEvent');
        });
    }

    // related
    if ($('.Presta').length) {
        var $this = $('meta[itemprop="url"]');
        var date = $this.data("date");
        var href = $this.attr("content") + '/related?date=' + date;
        Apidae_Util.ajaxSend('#related');

        $.get(href, function(data) {
            $('#related').append(data);
            $('#slider-related').bxSlider({
                slideWidth: 333,
                slideMargin: 15,
                minSlides: 1,
                maxSlides: 3,
                nextSelector: '#slider-related-next',
                prevSelector: '#slider-related-prev',
                nextText: '<i class"fal fa-chevron-right" aria-hidden="true"></i>',
                prevText: '<i class"fal fa-chevron-left" aria-hidden="true"></i>',
                pager: false,
                auto: false
            });
            Apidae_Util.ajaxComplete('#related');
        });
    }

});